import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {kmApiLink, Scenario} from "@pg-mono/km-routes";
import {RegionType} from "@pg-rp/common-types";

import {getIgnoredNotifyResponse} from "../../../store/utils/get_ignored_notify_response";
import {kmApi} from "../../km_app/api/km_api";
import {ALLOWED_CITIES_FOR_REGIONS_SELECTION_ON_MAP} from "../../map/constants/allowed_cities_for_regions_selection_on_map";
import {DISABLE_DISTRICTS_AND_SURROUNDINGS_MAP_FOR_REGIONS} from "../../map/constants/disable_districts_and_surroundings_map_for_regions";
import {DISABLE_DISTRICTS_OR_SURROUNDINGS_FOR_MAP_VIEW} from "../../map/constants/disable_districts_or_surroundings_for_map_view";
import {GetListMapRegionItemDto} from "../types/GetListMapRegionItemDto";

const multiRegionListLink = kmApiLink.regions.base(Scenario.REGION_LIST_MAP);

interface IRequestParams {
    parent: number;
}

interface IResponse {
    results: GetListMapRegionItemDto[];
}

const RESULTS_LIMIT = 100;

export const getMapRegionDistrictsAndSurroundings = kmApi.injectEndpoints({
    endpoints: (build) => ({
        getMapRegionDistrictsAndSurroundings: build.query<IResponse, IRequestParams>({
            queryFn: async (queryParams, api, _extraOptions, fetchBaseQuery) => {
                if (ALLOWED_CITIES_FOR_REGIONS_SELECTION_ON_MAP !== null && !ALLOWED_CITIES_FOR_REGIONS_SELECTION_ON_MAP?.includes(queryParams.parent)) {
                    return {data: {results: []}};
                }

                if (DISABLE_DISTRICTS_AND_SURROUNDINGS_MAP_FOR_REGIONS.includes(queryParams.parent)) {
                    return {data: {results: []}};
                }

                const queryResponse = (await fetchBaseQuery({
                    url: multiRegionListLink,
                    method: "GET",
                    params: {
                        parent: queryParams.parent,
                        type: [RegionType.DISTRICT, RegionType.SURROUNDINGS],
                        page_size: RESULTS_LIMIT
                    }
                })) as {data: IResponse; error?: FetchBaseQueryError};

                if (queryResponse.error) {
                    return {
                        error: getIgnoredNotifyResponse(queryResponse.error, [400, 404])
                    };
                }

                return {
                    data: {
                        results: queryResponse.data.results.filter((record) => {
                            return !DISABLE_DISTRICTS_OR_SURROUNDINGS_FOR_MAP_VIEW.includes(record.id);
                        })
                    }
                };
            }
        })
    })
});

export const {useGetMapRegionDistrictsAndSurroundingsQuery, useLazyGetMapRegionDistrictsAndSurroundingsQuery} = getMapRegionDistrictsAndSurroundings;
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {kmApiLink, Scenario} from "@pg-mono/km-routes";
import {RegionType} from "@pg-rp/common-types";

import {getIgnoredNotifyResponse} from "../../../store/utils/get_ignored_notify_response";
import {kmApi} from "../../km_app/api/km_api";
import {ALLOWED_CITIES_FOR_REGIONS_SELECTION_ON_MAP} from "../../map/constants/allowed_cities_for_regions_selection_on_map";
import {DISABLE_DISTRICTS_AND_SURROUNDINGS_MAP_FOR_REGIONS} from "../../map/constants/disable_districts_and_surroundings_map_for_regions";
import {DISABLE_DISTRICTS_OR_SURROUNDINGS_FOR_MAP_VIEW} from "../../map/constants/disable_districts_or_surroundings_for_map_view";
import {GetListMapRegionItemDto} from "../types/GetListMapRegionItemDto";

const multiRegionListLink = kmApiLink.regions.base(Scenario.REGION_LIST_MAP);

interface IRequestParams {
    parent: number;
}

interface IResponse {
    results: GetListMapRegionItemDto[];
}

const RESULTS_LIMIT = 100;

export const getMapRegionDistrictsAndSurroundings = kmApi.injectEndpoints({
    endpoints: (build) => ({
        getMapRegionDistrictsAndSurroundings: build.query<IResponse, IRequestParams>({
            queryFn: async (queryParams, api, _extraOptions, fetchBaseQuery) => {
                if (ALLOWED_CITIES_FOR_REGIONS_SELECTION_ON_MAP !== null && !ALLOWED_CITIES_FOR_REGIONS_SELECTION_ON_MAP?.includes(queryParams.parent)) {
                    return {data: {results: []}};
                }

                if (DISABLE_DISTRICTS_AND_SURROUNDINGS_MAP_FOR_REGIONS.includes(queryParams.parent)) {
                    return {data: {results: []}};
                }

                const queryResponse = (await fetchBaseQuery({
                    url: multiRegionListLink,
                    method: "GET",
                    params: {
                        parent: queryParams.parent,
                        type: [RegionType.DISTRICT, RegionType.SURROUNDINGS],
                        page_size: RESULTS_LIMIT
                    }
                })) as {data: IResponse; error?: FetchBaseQueryError};

                if (queryResponse.error) {
                    return {
                        error: getIgnoredNotifyResponse(queryResponse.error, [400, 404])
                    };
                }

                return {
                    data: {
                        results: queryResponse.data.results.filter((record) => {
                            return !DISABLE_DISTRICTS_OR_SURROUNDINGS_FOR_MAP_VIEW.includes(record.id);
                        })
                    }
                };
            }
        })
    })
});

export const {useGetMapRegionDistrictsAndSurroundingsQuery, useLazyGetMapRegionDistrictsAndSurroundingsQuery} = getMapRegionDistrictsAndSurroundings;
